import { useEffect } from "react";
import "@/App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Outlet,
} from "react-router-dom";
import { Toaster } from "sonner";
import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Products from "@/pages/Products";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import CrmLogin from "@/pages/CrmLogin";
import CrmDashboard from "@/pages/CrmDashboard";
import CrmProfile from "@/pages/CrmProfile";
import VendorApply from "@/pages/VendorApply";
import Careers from "@/pages/Careers";
import EmployeeDashboard from "@/pages/EmployeeDashboard";
import OfferRespond from "@/pages/OfferRespond";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname, hash]);
  return null;
};

// Public layout wraps marketing pages with Navbar/Footer
const PublicLayout = () => (
  <>
    <Navbar />
    <Outlet />
    <Footer />
  </>
);

function App() {
  const paypalOptions = {
    clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID || "test",
    currency: "USD",
    intent: "capture",
    components: "buttons",
  };

  return (
    <div className="App">
      <AuthProvider>
        <PayPalScriptProvider options={paypalOptions} deferLoading={false}>
          <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/products" element={<Products />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/partner" element={<VendorApply />} />
              <Route path="/careers" element={<Careers />} />
            </Route>

            <Route path="/offer/:token" element={<OfferRespond />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            <Route path="/crm/login" element={<CrmLogin />} />
            <Route
              path="/crm"
              element={
                <ProtectedRoute>
                  <CrmDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/crm/profile"
              element={
                <ProtectedRoute>
                  <CrmProfile />
                </ProtectedRoute>
              }
            />

            <Route path="/hrms/login" element={<CrmLogin />} />
            <Route
              path="/hrms"
              element={
                <ProtectedRoute>
                  <EmployeeDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="*"
              element={
                <PublicLayout>
                  <Home />
                </PublicLayout>
              }
            />
          </Routes>
          <Toaster
            position="top-right"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0B132B",
                border: "1px solid rgba(255,255,255,0.1)",
                color: "#fff",
                fontFamily: "IBM Plex Sans, sans-serif",
              },
            }}
          />
        </BrowserRouter>
        </PayPalScriptProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
